import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Spinner } from "react-bootstrap";
import "./_assignment.scss"
import moment from "moment";
import CardLessDataTableWithSearch from '../datatables/CardLessDataTableWithSearch';
import StudentDetailsModal from './StudentDetailsModal';



class AssignmentStudentDetailsHome extends Component {
  constructor(props) {
    super(props);
    this.state = {  
      blockType: "1",
      viewDetailsModal: false,
      creationDetailsModal: false,
      individualStudentData: [],
      loadingSpinner: 0,
      currentStep: 1,
      submitError: "",
      seenUnseenId: 0,
      count: 0,
    }
  }

  articlecolumns3 = [
    {
      dataField: "student_name",
      text: "Student Name",
      // attrs:{width:50,className:"student_names"}
    },

    {
      dataField: "roll_no",
      text: "Roll No.",
    },

    {
      dataField: "submitted_date",
      text: "Submitted Date",
    },

    {
      dataField: 'View Details',
      formatter: this.PerformanceFunc.bind(this),
      text: 'View Details',
    },
  ];

  articlecolumns1 = [
    {
      dataField: "student_name",
      text: "Student Name",
    },
    {
      dataField: "roll_no",
      text: "Roll No.",
    },
  ];

  articlecolumns2 = [
    {
      dataField: "student_name",
      text: "Student Name",
    },
    {
      dataField: "roll_no",
      text: "Roll No.",
    },
    {
      dataField: "viewed_date",
      text: "Assignment Viewed Date",
    },

  ];

  tableData1(data) {
    let returnData = data.map((item) => {
      return {
        student_name: item.student_name,
        roll_no: item.roll_no,
      };
    });
    return returnData;
  }

  tableData2(data) {
    console.log(data, "oooooooo")
    let returnData = data.map((item) => {
      return {
        student_name: item.student_name,
        roll_no: item.roll_no,
        viewed_date: moment.unix(item.timestamp).format("DD-MM-YYYY"),
    };
    });
    return returnData;
  }

  PerformanceFunc(val, row) {
    console.log(row, "qqqqqqq")
    return (
      <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.setState({ viewDetailsModal: true, individualStudentData: row.individualStudentData })}>
        <Button variant="link" name="view" className="text-theme">
          <i className="fas fa-eye" />
        </Button>
        <span>
            {
              row.individualStudentData.marks !== null && row.individualStudentData.verifier_comments !== "" ?("(Verified)"):""
            }
          </span>
      </div>
    );
  };


  tableData3(data) {
    console.log(data, "dataing")
    let returnData = [];
    data.sort((a, b) => {
      const aIsEmpty = a.marks !== "" && a.verifier_comments !== "";
      const bIsEmpty = b.marks !== "" && b.verifier_comments !== "";
      
      if (aIsEmpty && !bIsEmpty) {
          return 1;
      } else if (!aIsEmpty && bIsEmpty) {
          return -1;
      } else {
          return 0;
      }
  });
    data.map((item) => {
      const newObj = {
        student_name: item.student_name,
        roll_no: item.roll_no,
        submitted_date: moment.unix(item.submitted_time).format("DD-MM-YYYY"),
        marks: item.marks,
        verifier_comments: item.verifier_comments,
        individualStudentData: item
      }
      returnData.push(newObj);

    })
    return returnData;

  }

render() {

    console.log(this.state, "helloooooooooooo")

    const studentData =
        this.props.getStudentDairyAssignmentDetails
            .getStudentDairyAssignmentDetails
            .statusSubmitData

    let studentFilterData = []

    let notSeenStudents =
        this.props.getStudentDairyAssignmentDetails
            .getStudentDairyAssignmentDetails
            .statusNotSeenData.length

    let seenStudents = 0
    let completedStudents = 0

    if (studentData !== undefined) {

        if (this.state.blockType == "2") {
            studentFilterData =
                studentData.filter((item) => item.status == "1")
        }

        else if (this.state.blockType == "3") {
            studentFilterData =
                studentData.filter((item) => item.status == "2")
        }

        notSeenStudents =
            this.props.getStudentDairyAssignmentDetails
                .getStudentDairyAssignmentDetails
                .statusNotSeenData.length

        seenStudents =
            this.props.getStudentDairyAssignmentDetails
                .getStudentDairyAssignmentDetails
                .statusSubmitData
                .filter((item) => item.status == "1").length

        completedStudents =
            this.props.getStudentDairyAssignmentDetails
                .getStudentDairyAssignmentDetails
                .statusSubmitData
                .filter((item) => item.status == "2").length
    }

    const styles = {

        page: {
            background:
                "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)",
            minHeight: "100vh",
            padding: "28px 24px",
        },

        pageTitle: {
            fontSize: 24,
            fontWeight: 700,
            color: "#111827",
            marginBottom: 24,
        },

        statGrid: {
            display: "grid",
            gridTemplateColumns:
                "repeat(auto-fit,minmax(260px,1fr))",
            gap: 20,
            marginBottom: 24,
        },

        statCard: {
            borderRadius: 20,
            padding: "22px",
            cursor: "pointer",
            transition: "0.3s",
            border: "none",
            position: "relative",
            overflow: "hidden",
        },

        activeCard: {
            background:
                "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
            color: "#fff",
            boxShadow:
                "0 8px 24px rgba(99,102,241,0.35)",
        },

        inactiveCard: {
            background: "#fff",
            color: "#111827",
            boxShadow:
                "0 2px 16px rgba(0,0,0,0.07)",
        },

        statTop: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 12,
        },

        statLabel: {
            fontSize: 13,
            fontWeight: 600,
            opacity: 0.9,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
        },

        statValue: {
            fontSize: 36,
            fontWeight: 800,
            lineHeight: 1,
        },

        statIcon: {
            width: 56,
            height: 56,
            borderRadius: 16,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 24,
            background: "rgba(255,255,255,0.15)",
        },

        tableCard: {
            background: "#fff",
            borderRadius: 22,
            boxShadow:
                "0 2px 16px rgba(0,0,0,0.07)",
            border: "none",
            overflow: "hidden",
        },

        tableHeader: {
            background:
                "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
            padding: "18px 24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 12,
        },

        tableHeaderTitle: {
            color: "#fff",
            fontWeight: 700,
            fontSize: 18,
            margin: 0,
        },

        countBadge: {
            background: "rgba(255,255,255,0.15)",
            color: "#fff",
            padding: "6px 14px",
            borderRadius: 20,
            fontSize: 13,
            fontWeight: 700,
        },

        tableBody: {
            padding: "24px",
        },

        tableWrapper: {
            borderRadius: 16,
            overflow: "hidden",
            border: "1px solid #e5e7eb",
        },

        emptyState: {
            textAlign: "center",
            padding: "70px 20px",
            color: "#9ca3af",
        },

        emptyIcon: {
            fontSize: 52,
            marginBottom: 12,
            display: "block",
        },

        emptyText: {
            fontWeight: 600,
            fontSize: 16,
            color: "#6b7280",
        },
    };

    return (

        <div style={styles.page}>

            <Container fluid>

                {/* TITLE */}

                <div style={styles.pageTitle}>
                    Student Status Details
                </div>

                {/* STATUS CARDS */}

                <div style={styles.statGrid}>

                    {/* NOT SEEN */}

                    <div
                        onClick={() =>
                            this.setState({ blockType: "1" })
                        }
                        style={{
                            ...styles.statCard,
                            ...(this.state.blockType == "1"
                                ? styles.activeCard
                                : styles.inactiveCard)
                        }}
                    >

                        <div style={styles.statTop}>

                            <div>

                                <div style={styles.statLabel}>
                                    Not Seen
                                </div>

                                <div style={styles.statValue}>
                                    {notSeenStudents}
                                </div>

                            </div>

                            <div style={styles.statIcon}>
                                👁️
                            </div>

                        </div>

                    </div>

                    {/* VIEWED */}

                    <div
                        onClick={() =>
                            this.setState({ blockType: "2" })
                        }
                        style={{
                            ...styles.statCard,
                            ...(this.state.blockType == "2"
                                ? styles.activeCard
                                : styles.inactiveCard)
                        }}
                    >

                        <div style={styles.statTop}>

                            <div>

                                <div style={styles.statLabel}>
                                    Assignment Viewed
                                </div>

                                <div style={styles.statValue}>
                                    {seenStudents}
                                </div>

                            </div>

                            <div style={styles.statIcon}>
                                👀
                            </div>

                        </div>

                    </div>

                    {/* COMPLETED */}

                    <div
                        onClick={() =>
                            this.setState({ blockType: "3" })
                        }
                        style={{
                            ...styles.statCard,
                            ...(this.state.blockType == "3"
                                ? styles.activeCard
                                : styles.inactiveCard)
                        }}
                    >

                        <div style={styles.statTop}>

                            <div>

                                <div style={styles.statLabel}>
                                    Assignment Completed
                                </div>

                                <div style={styles.statValue}>
                                    {completedStudents}
                                </div>

                            </div>

                            <div style={styles.statIcon}>
                                ✅
                            </div>

                        </div>

                    </div>

                </div>

                {/* TABLE CARD */}

                <div style={styles.tableCard}>

                    <div style={styles.tableHeader}>

                        <h5 style={styles.tableHeaderTitle}>

                            {
                                this.state.blockType == "1"
                                    ? "Not Seen Students"
                                    : this.state.blockType == "2"
                                        ? "Viewed Students"
                                        : "Completed Students"
                            }

                        </h5>

                        <div style={styles.countBadge}>

                            {
                                this.state.blockType == "1"
                                    ? notSeenStudents
                                    : studentFilterData.length
                            }

                            {" "}Students

                        </div>

                    </div>

                    <div style={styles.tableBody}>

                        {/* NOT SEEN */}

                        {this.state.blockType == "1" && (

                            this.props
                                .getStudentDairyAssignmentDetails
                                .getStudentDairyAssignmentDetails
                                .statusNotSeenData.length > 0 ? (

                                <div style={styles.tableWrapper}>

                                    <CardLessDataTableWithSearch
                                        parentData={
                                            this.tableData1(
                                                this.props
                                                    .getStudentDairyAssignmentDetails
                                                    .getStudentDairyAssignmentDetails
                                                    .statusNotSeenData
                                            )
                                        }
                                        particlecolumns={
                                            this.articlecolumns1
                                        }
                                        name="attendance"
                                    />

                                </div>

                            ) : (

                                <div style={styles.emptyState}>

                                    <span style={styles.emptyIcon}>
                                        📂
                                    </span>

                                    <div style={styles.emptyText}>
                                        No Students Found
                                    </div>

                                </div>

                            )
                        )}

                        {/* VIEWED */}

                        {this.state.blockType == "2" && (

                            studentFilterData.length > 0 ? (

                                <div style={styles.tableWrapper}>

                                    <CardLessDataTableWithSearch
                                        parentData={
                                            this.tableData2(
                                                studentFilterData
                                            )
                                        }
                                        particlecolumns={
                                            this.articlecolumns2
                                        }
                                        name="attendance"
                                    />

                                </div>

                            ) : (

                                <div style={styles.emptyState}>

                                    <span style={styles.emptyIcon}>
                                        👀
                                    </span>

                                    <div style={styles.emptyText}>
                                        No Viewed Students
                                    </div>

                                </div>

                            )
                        )}

                        {/* COMPLETED */}

                        {this.state.blockType == "3" && (

                            studentFilterData.length > 0 ? (

                                <div style={styles.tableWrapper}>

                                    <CardLessDataTableWithSearch
                                        parentData={
                                            this.tableData3(
                                                studentFilterData
                                            )
                                        }
                                        particlecolumns={
                                            this.articlecolumns3
                                        }
                                        name="attendance"
                                    />

                                </div>

                            ) : (

                                <div style={styles.emptyState}>

                                    <span style={styles.emptyIcon}>
                                        ✅
                                    </span>

                                    <div style={styles.emptyText}>
                                        No Completed Students
                                    </div>

                                </div>

                            )
                        )}

                    </div>

                </div>

                {/* MODAL */}

                <StudentDetailsModal
                    stateData={this.state}
                    show={this.state.viewDetailsModal}
                    onHide={() =>
                        this.setState({
                            viewDetailsModal: false
                        })
                    }
                    getStudentDairyAssignmentDetails={
                        this.props
                            .getStudentDairyAssignmentDetails
                    }
                />

            </Container>

        </div>
    )
}
}

export default AssignmentStudentDetailsHome